module.exports = __webpack_public_path__ + "static/dayview-88f7ec4a8d37fb5c4d0088302ca89070.png";